import React, { createContext, useContext, useState, useMemo, useEffect } from "react";

// Create context
const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);

  // Load from sessionStorage on initial render
  useEffect(() => {
    const storedData = sessionStorage.getItem("userData");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setAdmin(parsed?.token); // assumes token contains the user info
    }
  }, []);

  const login = (adminData) => {
    setAdmin(adminData);
    const payload = {
      token: adminData,
      loggedIn: true,
    };
    sessionStorage.setItem("userData", JSON.stringify(payload));
  };

  const logout = () => {
    setAdmin(null);
    sessionStorage.removeItem("userData");
  };

  const value = useMemo(() => ({ admin, login, logout }), [admin]);

  return (
    <AdminContext.Provider value={value}>{children}</AdminContext.Provider>
  );
};

export const useAdmin = () => useContext(AdminContext);
